import { Content, SetupSidebar } from 'views/components/Layout';
import React from 'react';
import { MdImportantDevices } from 'react-icons/md';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../Routes/PrivateRoute';
import PageSpinner from '../PageSpinner';
import { setupRoutes } from 'views/routes';

class SetupLayout extends React.Component {
  static isSidebarOpen() {
    const sideBar = document.querySelector('.cr-sidebar');
    if (sideBar) return sideBar.classList.contains('cr-sidebar--open');
  }

  componentWillReceiveProps({ breakpoint }) {
    if (breakpoint !== this.props.breakpoint) {
      this.checkBreakpoint(breakpoint);
    }
  }

  componentDidMount() {
    this.checkBreakpoint(this.props.breakpoint);
  }

  // close sidebar when
  handleContentClick = event => {
    // close sidebar if sidebar is open and screen size is less than `md`
    if (
      SetupLayout.isSidebarOpen() &&
      (this.props.breakpoint === 'xs' || this.props.breakpoint === 'sm' || this.props.breakpoint === 'md')
    ) {
      this.openSidebar('close');
    }
  };

  checkBreakpoint(breakpoint) {
    switch (breakpoint) {
      case 'xs':
      case 'sm':
      case 'md':
        return this.openSidebar('close');

      case 'lg':
      case 'xl':
      default:
        return this.openSidebar('open');
    }
  }

  openSidebar(openOrClose) {
    const sideBar = document.querySelector('.cr-sidebar');
    if (sideBar) {
      if (openOrClose === 'open') {
        return sideBar.classList.add('cr-sidebar--open');
      }
      sideBar.classList.remove('cr-sidebar--open');
    }
  }

  render() {
    const showSteps = window.location.hash.includes('showSteps=true');

    return (
      <div className="cr-app bg-app" style={{ overflow: 'hidden' }}>
        {!showSteps && <SetupSidebar />}

        <Content fluid onClick={this.handleContentClick}>
          <Switch>
            <React.Suspense fallback={<PageSpinner />}>
              {setupRoutes.map((route, idx) => {
                return (
                  <PrivateRoute
                    key={idx}
                    exact={route.exact}
                    path={`/setup${route.path}`}
                    component={route.component}
                  />
                );
              })}
            </React.Suspense>
          </Switch>
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SetupLayout);
